import React, { Component } from "react";
import { toast } from "react-toastify";
import { getMyEquipments, getBillingCycles, changeBillingCycle } from "../services/equipmentService";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import PageLoading from "./common/pageLoading";
import Paper from "@material-ui/core/Paper";
import { StyledTableCell, StyledTableRow } from "../services/tableStyles";

class MyEquipment extends Component {
  state = {
    equipments: [],
    billingCycles: [],
    loading: "",
    processing: false,
    errors: {},
    equipmentToActOn: {},
    billingCycleId: "",
    showChangeModal: false,
  };

  constructor() {
    super();
    this.state.loading = true;
  }

  async componentDidMount() {
    await this.populateEquipments();
    await this.populateBillingCycle();
  }

  async populateEquipments() {
    try {
      const { data: equipments } = await getMyEquipments();
      this.setState({ equipments });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ loading: false });
  }

  async populateBillingCycle() {
    try {
      const { data: billingCycles } = await getBillingCycles();
      this.setState({ billingCycles });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ loading: false });
  }

  handleShowChangeModal = (equipmentToActOn) => {
    this.setState({ equipmentToActOn, showChangeModal: true });
  };

  handleSelectCycle = async (e) => {
    this.setState({ billingCycleId: e.currentTarget.value });
  };

  handleChangeCycle = async () => {
    this.setState({ processing: true });
    const { billingCycleId, equipmentToActOn } = this.state;

    try {
      await changeBillingCycle(equipmentToActOn._id, billingCycleId);

      this.setState({ showChangeModal: false });
      await this.populateEquipments();
      toast.success("Billing Cycle Changed");
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ processing: false });
  };

  handleClose = () => {
    this.setState({
      showChangeModal: false,
    });
  };

  render() {
    const {
      equipments,
      loading,
      showChangeModal,
      equipmentToActOn,
      billingCycles,
      billingCycleId,
      errors,
      processing,
    } = this.state;
    return (
      <React.Fragment>
        <Paper elevation={3}>
          <div className="card">
            <div className="card-header main-color-bg">
              <div>
                <h5>My Equipment</h5>
              </div>
            </div>
            <div className="card-body">
              <span className="card-text text-center">
                {loading && <PageLoading loading={loading} />}
                {loading === false && equipments.length === 0 && <span>No Equipment to Display</span>}
                {loading === false && equipments.length > 0 && (
                  <TableContainer component={Paper}>
                    <Table aria-label="customized table">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell>Name</StyledTableCell>
                          <StyledTableCell>SN</StyledTableCell>
                          <StyledTableCell>IP Address</StyledTableCell>
                          <StyledTableCell>Billing Cycle</StyledTableCell>
                          <StyledTableCell></StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {equipments.map((equipment) => (
                          <StyledTableRow key={equipment._id}>
                            <StyledTableCell>{equipment.name}</StyledTableCell>
                            <StyledTableCell>{equipment.sn}</StyledTableCell>
                            <StyledTableCell>{equipment.ipAcquisition}</StyledTableCell>
                            <StyledTableCell>{equipment.billingCycle}</StyledTableCell>
                            <StyledTableCell>
                              <Button
                                onClick={() =>
                                  this.handleShowChangeModal({
                                    _id: equipment._id,
                                    name: equipment.name,
                                    sn: equipment.sn,
                                  })
                                }
                                variant="primary"
                              >
                                Change Billing Cycle
                              </Button>
                            </StyledTableCell>
                          </StyledTableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </span>
            </div>
          </div>
        </Paper>
        <Modal show={showChangeModal} size="sm" onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Change Billing Cycle</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <React.Fragment>
              <Form.Group controlId="billingCycleId">
                <Form.Control
                  as="select"
                  custom
                  name="billingCycleId"
                  onChange={this.handleSelectCycle}
                  value={billingCycleId}
                  size="sm"
                  type="text"
                >
                  <option value="">Select Cycle</option>
                  {billingCycles.map((billingCycle) => (
                    <option key={billingCycle._id} value={billingCycle._id}>
                      {billingCycle.cycleName}
                    </option>
                  ))}
                </Form.Control>
                {errors.billingCycleId && <span className="text-danger">{errors.billingCycleId}</span>}
              </Form.Group>
            </React.Fragment>
          </Modal.Body>

          <Modal.Footer>
            <Button onClick={this.handleClose} variant="secondary">
              Close
            </Button>
            <Button
              onClick={this.handleChangeCycle}
              disabled={billingCycleId === "" || processing}
              type="button"
              variant="primary"
            >
              {processing && (
                <Spinner as="span" className="mr-2" animation="border" size="sm" role="status" aria-hidden="true" />
              )}
              Change
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }
}

export default MyEquipment;
